export const countries = [
    { enName: 'Afghanistan', deName: 'Afghanistan', code: 'af' },
    {
        enName: 'Åland Islands',
        deName: 'Åland',
        code: 'ax'
    },
    { enName: 'Albania', deName: 'Albanien', code: 'al' },
    {
        enName: 'Algeria',
        deName: 'Algerien',
        code: 'dz'
    },
    { enName: 'American Samoa', deName: 'Amerikanisch-Samoa', code: 'as' },
    {
        enName: 'Andorra',
        deName: 'Andorra',
        code: 'ad'
    },
    { enName: 'Angola', deName: 'Angola', code: 'ao' },
    {
        enName: 'Anguilla',
        deName: 'Anguilla',
        code: 'ai'
    },
    { enName: 'Antarctica', deName: 'Antarktis', code: 'aq' },
    {
        enName: 'Antigua and Barbuda',
        deName: 'Antigua und Barbuda',
        code: 'ag'
    },
    { enName: 'Argentina', deName: 'Argentinien', code: 'ar' },
    {
        enName: 'Armenia',
        deName: 'Armenien',
        code: 'am'
    },
    { enName: 'Aruba', deName: 'Aruba', code: 'aw' },
    {
        enName: 'Australia',
        deName: 'Australien',
        code: 'au'
    },
    { enName: 'Austria', deName: 'Österreich', code: 'at' },
    {
        enName: 'Azerbaijan',
        deName: 'Aserbaidschan',
        code: 'az'
    },
    { enName: 'Bahamas', deName: 'Bahamas', code: 'bs' },
    {
        enName: 'Bahrain',
        deName: 'Bahrain',
        code: 'bh'
    },
    { enName: 'Bangladesh', deName: 'Bangladesch', code: 'bd' },
    {
        enName: 'Barbados',
        deName: 'Barbados',
        code: 'bb'
    },
    { enName: 'Belarus', deName: 'Belarus', code: 'by' },
    {
        enName: 'Belgium',
        deName: 'Belgien',
        code: 'be'
    },
    { enName: 'Belize', deName: 'Belize', code: 'bz' },
    {
        enName: 'Benin',
        deName: 'Benin',
        code: 'bj'
    },
    { enName: 'Bermuda', deName: 'Bermuda', code: 'bm' },
    {
        enName: 'Bhutan',
        deName: 'Bhutan',
        code: 'bt'
    },
    {
        enName: 'Bolivia (Plurinational State of)',
        deName: 'Bolivien',
        code: 'bo'
    },
    {
        enName: 'Bonaire, Sint Eustatius and Saba',
        deName: 'Bonaire',
        code: 'bq'
    },
    { enName: 'Bosnia and Herzegovina', deName: 'Bosnien und Herzegowina', code: 'ba' },
    {
        enName: 'Botswana',
        deName: 'Botswana',
        code: 'bw'
    },
    { enName: 'Bouvet Island', deName: 'Bouvetinsel', code: 'bv' },
    {
        enName: 'Brazil',
        deName: 'Brasilien',
        code: 'br'
    },
    {
        enName: 'British Indian Ocean Territory',
        deName: 'Britisches Territorium im Indischen Ozean',
        code: 'io'
    },
    { enName: 'Brunei Darussalam', deName: 'Brunei Darussalam', code: 'bn' },
    {
        enName: 'Bulgaria',
        deName: 'Bulgarien',
        code: 'bg'
    },
    { enName: 'Burkina Faso', deName: 'Burkina Faso', code: 'bf' },
    {
        enName: 'Burundi',
        deName: 'Burundi',
        code: 'bi'
    },
    { enName: 'Cabo Verde', deName: 'Kap Verde', code: 'cv' },
    {
        enName: 'Cambodia',
        deName: 'Kambodscha',
        code: 'kh'
    },
    { enName: 'Cameroon', deName: 'Kamerun', code: 'cm' },
    {
        enName: 'Canada',
        deName: 'Kanada',
        code: 'ca'
    },
    { enName: 'Cayman Islands', deName: 'Kaimaninseln', code: 'ky' },
    {
        enName: 'Central African Republic',
        deName: 'Zentralafrikanische Republik',
        code: 'cf'
    },
    { enName: 'Chad', deName: 'Tschad', code: 'td' },
    {
        enName: 'Chile',
        deName: 'Chile',
        code: 'cl'
    },
    { enName: 'China', deName: 'China', code: 'cn' },
    {
        enName: 'Christmas Island',
        deName: 'Weihnachtsinsel',
        code: 'cx'
    },
    { enName: 'Cocos (Keeling) Islands', deName: 'Kokosinseln', code: 'cc' },
    {
        enName: 'Colombia',
        deName: 'Kolumbien',
        code: 'co'
    },
    { enName: 'Comoros', deName: 'Komoren', code: 'km' },
    {
        enName: 'Congo',
        deName: 'Republik Kongo',
        code: 'cg'
    },
    { enName: 'Congo, Democratic Republic of the', deName: 'Kongo', code: 'cd' },
    {
        enName: 'Cook Islands',
        deName: 'Cookinseln',
        code: 'ck'
    },
    { enName: 'Costa Rica', deName: 'Costa Rica', code: 'cr' },
    {
        enName: "Côte d'Ivoire",
        deName: 'Elfenbeinküste',
        code: 'ci'
    },
    { enName: 'Croatia', deName: 'Kroatien', code: 'hr' },
    {
        enName: 'Cuba',
        deName: 'Kuba',
        code: 'cu'
    },
    { enName: 'Curaçao', deName: 'Curaçao', code: 'cw' },
    {
        enName: 'Cyprus',
        deName: 'Zypern',
        code: 'cy'
    },
    { enName: 'Czechia', deName: 'Tschechische Republik', code: 'cz' },
    {
        enName: 'Denmark',
        deName: 'Dänemark',
        code: 'dk'
    },
    { enName: 'Djibouti', deName: 'Dschibuti', code: 'dj' },
    {
        enName: 'Dominica',
        deName: 'Dominica',
        code: 'dm'
    },
    { enName: 'Dominican Republic', deName: 'Dominikanische Republik', code: 'do' },
    {
        enName: 'Ecuador',
        deName: 'Ecuador',
        code: 'ec'
    },
    { enName: 'Egypt', deName: 'Ägypten', code: 'eg' },
    {
        enName: 'El Salvador',
        deName: 'El Salvador',
        code: 'sv'
    },
    { enName: 'Equatorial Guinea', deName: 'Äquatorialguinea', code: 'gq' },
    {
        enName: 'Eritrea',
        deName: 'Eritrea',
        code: 'er'
    },
    { enName: 'Estonia', deName: 'Estland', code: 'ee' },
    {
        enName: 'Eswatini',
        deName: 'Eswatini',
        code: 'sz'
    },
    { enName: 'Ethiopia', deName: 'Äthiopien', code: 'et' },
    {
        enName: 'Falkland Islands (Malvinas)',
        deName: 'Falklandinseln',
        code: 'fk'
    },
    { enName: 'Faroe Islands', deName: 'Färöer', code: 'fo' },
    {
        enName: 'Fiji',
        deName: 'Fidschi',
        code: 'fj'
    },
    { enName: 'Finland', deName: 'Finnland', code: 'fi' },
    {
        enName: 'France',
        deName: 'Frankreich',
        code: 'fr'
    },
    { enName: 'French Guiana', deName: 'Französisch-Guayana', code: 'gf' },
    {
        enName: 'French Polynesia',
        deName: 'Französisch-Polynesien',
        code: 'pf'
    },
    {
        enName: 'French Southern Territories',
        deName: 'Französische Süd- und Antarktisgebiete',
        code: 'tf'
    },
    { enName: 'Gabon', deName: 'Gabun', code: 'ga' },
    {
        enName: 'Gambia',
        deName: 'Gambia',
        code: 'gm'
    },
    { enName: 'Georgia', deName: 'Georgien', code: 'ge' },
    {
        enName: 'Germany',
        deName: 'Deutschland',
        code: 'de'
    },
    { enName: 'Ghana', deName: 'Ghana', code: 'gh' },
    {
        enName: 'Gibraltar',
        deName: 'Gibraltar',
        code: 'gi'
    },
    { enName: 'Greece', deName: 'Griechenland', code: 'gr' },
    {
        enName: 'Greenland',
        deName: 'Grönland',
        code: 'gl'
    },
    { enName: 'Grenada', deName: 'Grenada', code: 'gd' },
    {
        enName: 'Guadeloupe',
        deName: 'Guadeloupe',
        code: 'gp'
    },
    { enName: 'Guam', deName: 'Guam', code: 'gu' },
    {
        enName: 'Guatemala',
        deName: 'Guatemala',
        code: 'gt'
    },
    { enName: 'Guernsey', deName: 'Guernsey', code: 'gg' },
    {
        enName: 'Guinea',
        deName: 'Guinea',
        code: 'gn'
    },
    { enName: 'Guinea-Bissau', deName: 'Guinea-Bissau', code: 'gw' },
    {
        enName: 'Guyana',
        deName: 'Guyana',
        code: 'gy'
    },
    { enName: 'Haiti', deName: 'Haiti', code: 'ht' },
    {
        enName: 'Heard Island and McDonald Islands',
        deName: 'Heard und McDonaldinseln',
        code: 'hm'
    },
    { enName: 'Holy See', deName: 'Vatikanstadt', code: 'va' },
    {
        enName: 'Honduras',
        deName: 'Honduras',
        code: 'hn'
    },
    { enName: 'Hong Kong', deName: 'Hongkong', code: 'hk' },
    {
        enName: 'Hungary',
        deName: 'Ungarn',
        code: 'hu'
    },
    { enName: 'Iceland', deName: 'Island', code: 'is' },
    {
        enName: 'India',
        deName: 'Indien',
        code: 'in'
    },
    { enName: 'Indonesia', deName: 'Indonesien', code: 'id' },
    {
        enName: 'Iran (Islamic Republic of)',
        deName: 'Iran',
        code: 'ir'
    },
    { enName: 'Iraq', deName: 'Irak', code: 'iq' },
    {
        enName: 'Ireland',
        deName: 'Irland',
        code: 'ie'
    },
    { enName: 'Isle of Man', deName: 'Insel Man', code: 'im' },
    {
        enName: 'Israel',
        deName: 'Israel',
        code: 'il'
    },
    { enName: 'Italy', deName: 'Italien', code: 'it' },
    {
        enName: 'Jamaica',
        deName: 'Jamaika',
        code: 'jm'
    },
    { enName: 'Japan', deName: 'Japan', code: 'jp' },
    {
        enName: 'Jersey',
        deName: 'Jersey',
        code: 'je'
    },
    { enName: 'Jordan', deName: 'Jordanien', code: 'jo' },
    {
        enName: 'Kazakhstan',
        deName: 'Kasachstan',
        code: 'kz'
    },
    { enName: 'Kenya', deName: 'Kenia', code: 'ke' },
    {
        enName: 'Kiribati',
        deName: 'Kiribati',
        code: 'ki'
    },
    {
        enName: "Korea (Democratic People's Republic of)",
        deName: 'Nordkorea',
        code: 'kp'
    },
    { enName: 'Korea, Republic of', deName: 'Südkorea', code: 'kr' },
    {
        enName: 'Kuwait',
        deName: 'Kuwait',
        code: 'kw'
    },
    { enName: 'Kyrgyzstan', deName: 'Kirgisistan', code: 'kg' },
    {
        enName: "Lao People's Democratic Republic",
        deName: 'Laos',
        code: 'la'
    },
    { enName: 'Latvia', deName: 'Lettland', code: 'lv' },
    {
        enName: 'Lebanon',
        deName: 'Libanon',
        code: 'lb'
    },
    { enName: 'Lesotho', deName: 'Lesotho', code: 'ls' },
    {
        enName: 'Liberia',
        deName: 'Liberia',
        code: 'lr'
    },
    { enName: 'Libya', deName: 'Libyen', code: 'ly' },
    {
        enName: 'Liechtenstein',
        deName: 'Liechtenstein',
        code: 'li'
    },
    { enName: 'Lithuania', deName: 'Litauen', code: 'lt' },
    {
        enName: 'Luxembourg',
        deName: 'Luxemburg',
        code: 'lu'
    },
    { enName: 'Macao', deName: 'Macao', code: 'mo' },
    {
        enName: 'Madagascar',
        deName: 'Madagaskar',
        code: 'mg'
    },
    { enName: 'Malawi', deName: 'Malawi', code: 'mw' },
    {
        enName: 'Malaysia',
        deName: 'Malaysia',
        code: 'my'
    },
    { enName: 'Maldives', deName: 'Malediven', code: 'mv' },
    {
        enName: 'Mali',
        deName: 'Mali',
        code: 'ml'
    },
    { enName: 'Malta', deName: 'Malta', code: 'mt' },
    {
        enName: 'Marshall Islands',
        deName: 'Marshallinseln',
        code: 'mh'
    },
    { enName: 'Martinique', deName: 'Martinique', code: 'mq' },
    {
        enName: 'Mauritania',
        deName: 'Mauretanien',
        code: 'mr'
    },
    { enName: 'Mauritius', deName: 'Mauritius', code: 'mu' },
    {
        enName: 'Mayotte',
        deName: 'Mayotte',
        code: 'yt'
    },
    { enName: 'Mexico', deName: 'Mexiko', code: 'mx' },
    {
        enName: 'Micronesia (Federated States of)',
        deName: 'Mikronesien',
        code: 'fm'
    },
    { enName: 'Moldova, Republic of', deName: 'Moldawien', code: 'md' },
    {
        enName: 'Monaco',
        deName: 'Monaco',
        code: 'mc'
    },
    { enName: 'Mongolia', deName: 'Mongolei', code: 'mn' },
    {
        enName: 'Montenegro',
        deName: 'Montenegro',
        code: 'me'
    },
    { enName: 'Montserrat', deName: 'Montserrat', code: 'ms' },
    {
        enName: 'Morocco',
        deName: 'Marokko',
        code: 'ma'
    },
    { enName: 'Mozambique', deName: 'Mosambik', code: 'mz' },
    {
        enName: 'Myanmar',
        deName: 'Myanmar',
        code: 'mm'
    },
    { enName: 'Namibia', deName: 'Namibia', code: 'na' },
    {
        enName: 'Nauru',
        deName: 'Nauru',
        code: 'nr'
    },
    { enName: 'Nepal', deName: 'Nepal', code: 'np' },
    {
        enName: 'Netherlands',
        deName: 'Niederlande',
        code: 'nl'
    },
    { enName: 'New Caledonia', deName: 'Neukaledonien', code: 'nc' },
    {
        enName: 'New Zealand',
        deName: 'Neuseeland',
        code: 'nz'
    },
    { enName: 'Nicaragua', deName: 'Nicaragua', code: 'ni' },
    {
        enName: 'Niger',
        deName: 'Niger',
        code: 'ne'
    },
    { enName: 'Nigeria', deName: 'Nigeria', code: 'ng' },
    {
        enName: 'Niue',
        deName: 'Niue',
        code: 'nu'
    },
    { enName: 'Norfolk Island', deName: 'Norfolkinsel', code: 'nf' },
    {
        enName: 'North Macedonia',
        deName: 'Nordmazedonien',
        code: 'mk'
    },
    { enName: 'Northern Mariana Islands', deName: 'Nördliche Marianen', code: 'mp' },
    {
        enName: 'Norway',
        deName: 'Norwegen',
        code: 'no'
    },
    { enName: 'Oman', deName: 'Oman', code: 'om' },
    {
        enName: 'Pakistan',
        deName: 'Pakistan',
        code: 'pk'
    },
    { enName: 'Palau', deName: 'Palau', code: 'pw' },
    {
        enName: 'Palestine, State of',
        deName: 'Staat Palästina',
        code: 'ps'
    },
    { enName: 'Panama', deName: 'Panama', code: 'pa' },
    {
        enName: 'Papua New Guinea',
        deName: 'Papua-Neuguinea',
        code: 'pg'
    },
    { enName: 'Paraguay', deName: 'Paraguay', code: 'py' },
    {
        enName: 'Peru',
        deName: 'Peru',
        code: 'pe'
    },
    { enName: 'Philippines', deName: 'Philippinen', code: 'ph' },
    {
        enName: 'Pitcairn',
        deName: 'Pitcairninseln',
        code: 'pn'
    },
    { enName: 'Poland', deName: 'Polen', code: 'pl' },
    {
        enName: 'Portugal',
        deName: 'Portugal',
        code: 'pt'
    },
    { enName: 'Puerto Rico', deName: 'Puerto Rico', code: 'pr' },
    {
        enName: 'Qatar',
        deName: 'Katar',
        code: 'qa'
    },
    { enName: 'Réunion', deName: 'Réunion', code: 're' },
    {
        enName: 'Romania',
        deName: 'Rumänien',
        code: 'ro'
    },
    { enName: 'Russian Federation', deName: 'Russische Föderation', code: 'ru' },
    {
        enName: 'Rwanda',
        deName: 'Ruanda',
        code: 'rw'
    },
    {
        enName: 'Saint Barthélemy',
        deName: 'Saint-Barthélemy',
        code: 'bl'
    },
    {
        enName: 'Saint Helena, Ascension and Tristan da Cunha',
        deName: 'St. Helena',
        code: 'sh'
    },
    { enName: 'Saint Kitts and Nevis', deName: 'St. Kitts und Nevis', code: 'kn' },
    {
        enName: 'Saint Lucia',
        deName: 'St. Lucia',
        code: 'lc'
    },
    {
        enName: 'Saint Martin (French part)',
        deName: 'Saint-Martin',
        code: 'mf'
    },
    {
        enName: 'Saint Pierre and Miquelon',
        deName: 'Saint-Pierre und Miquelon',
        code: 'pm'
    },
    {
        enName: 'Saint Vincent and the Grenadines',
        deName: 'St. Vincent und die Grenadinen',
        code: 'vc'
    },
    { enName: 'Samoa', deName: 'Samoa', code: 'ws' },
    {
        enName: 'San Marino',
        deName: 'San Marino',
        code: 'sm'
    },
    { enName: 'Sao Tome and Principe', deName: 'São Tomé und Príncipe', code: 'st' },
    {
        enName: 'Saudi Arabia',
        deName: 'Saudi-Arabien',
        code: 'sa'
    },
    { enName: 'Senegal', deName: 'Senegal', code: 'sn' },
    {
        enName: 'Serbia',
        deName: 'Serbien',
        code: 'rs'
    },
    { enName: 'Seychelles', deName: 'Seychellen', code: 'sc' },
    {
        enName: 'Sierra Leone',
        deName: 'Sierra Leone',
        code: 'sl'
    },
    { enName: 'Singapore', deName: 'Singapur', code: 'sg' },
    {
        enName: 'Sint Maarten (Dutch part)',
        deName: 'Sint Maarten',
        code: 'sx'
    },
    { enName: 'Slovakia', deName: 'Slowakei', code: 'sk' },
    {
        enName: 'Slovenia',
        deName: 'Slowenien',
        code: 'si'
    },
    { enName: 'Solomon Islands', deName: 'Salomonen', code: 'sb' },
    {
        enName: 'Somalia',
        deName: 'Somalia',
        code: 'so'
    },
    {
        enName: 'South Africa',
        deName: 'Südafrika',
        code: 'za'
    },
    {
        enName: 'South Georgia and the South Sandwich Islands',
        deName: 'Südgeorgien und die Südlichen Sandwichinseln',
        code: 'gs'
    },
    { enName: 'South Sudan', deName: 'Südsudan', code: 'ss' },
    {
        enName: 'Spain',
        deName: 'Spanien',
        code: 'es'
    },
    { enName: 'Sri Lanka', deName: 'Sri Lanka', code: 'lk' },
    {
        enName: 'Sudan',
        deName: 'Sudan',
        code: 'sd'
    },
    { enName: 'Suriname', deName: 'Suriname', code: 'sr' },
    {
        enName: 'Svalbard and Jan Mayen',
        deName: 'Svalbard und Jan Mayen',
        code: 'sj'
    },
    { enName: 'Sweden', deName: 'Schweden', code: 'se' },
    {
        enName: 'Switzerland',
        deName: 'Schweiz',
        code: 'ch'
    },
    {
        enName: 'Syrian Arab Republic',
        deName: 'Syrien, Arabische Republik',
        code: 'sy'
    },
    { enName: 'Taiwan, Province of China', deName: 'Taiwan', code: 'tw' },
    {
        enName: 'Tajikistan',
        deName: 'Tadschikistan',
        code: 'tj'
    },
    {
        enName: 'Tanzania, United Republic of',
        deName: 'Tansania, Vereinigte Republik',
        code: 'tz'
    },
    { enName: 'Thailand', deName: 'Thailand', code: 'th' },
    {
        enName: 'Timor-Leste',
        deName: 'Osttimor',
        code: 'tl'
    },
    { enName: 'Togo', deName: 'Togo', code: 'tg' },
    {
        enName: 'Tokelau',
        deName: 'Tokelau',
        code: 'tk'
    },
    { enName: 'Tonga', deName: 'Tonga', code: 'to' },
    {
        enName: 'Trinidad and Tobago',
        deName: 'Trinidad und Tobago',
        code: 'tt'
    },
    { enName: 'Tunisia', deName: 'Tunesien', code: 'tn' },
    {
        enName: 'Turkey',
        deName: 'Türkei',
        code: 'tr'
    },
    { enName: 'Turkmenistan', deName: 'Turkmenistan', code: 'tm' },
    {
        enName: 'Turks and Caicos Islands',
        deName: 'Turks- und Caicosinseln',
        code: 'tc'
    },
    { enName: 'Tuvalu', deName: 'Tuvalu', code: 'tv' },
    {
        enName: 'Uganda',
        deName: 'Uganda',
        code: 'ug'
    },
    { enName: 'Ukraine', deName: 'Ukraine', code: 'ua' },
    {
        enName: 'United Arab Emirates',
        deName: 'Vereinigte Arabische Emirate',
        code: 'ae'
    },
    {
        enName: 'United Kingdom of Great Britain and Northern Ireland',
        deName: ['Vereinigtes Königreich', 'Großbritannien'],
        code: 'gb'
    },
    {
        enName: 'United States of America',
        deName: ['Vereinigte Staaten von Amerika', 'Vereinigte Staaten', 'USA'],
        code: 'us'
    },
    {
        enName: 'United States Minor Outlying Islands',
        deName: 'United States Minor Outlying Islands',
        code: 'um'
    },
    { enName: 'Uruguay', deName: 'Uruguay', code: 'uy' },
    {
        enName: 'Uzbekistan',
        deName: 'Usbekistan',
        code: 'uz'
    },
    { enName: 'Vanuatu', deName: 'Vanuatu', code: 'vu' },
    {
        enName: 'Venezuela (Bolivarian Republic of)',
        deName: 'Venezuela',
        code: 've'
    },
    { enName: 'Viet Nam', deName: 'Vietnam', code: 'vn' },
    {
        enName: 'Virgin Islands (British)',
        deName: 'Britische Jungferninseln',
        code: 'vg'
    },
    {
        enName: 'Virgin Islands (U.S.)',
        deName: 'Amerikanische Jungferninseln',
        code: 'vi'
    },
    { enName: 'Wallis and Futuna', deName: 'Wallis und Futuna', code: 'wf' },
    {
        enName: 'Western Sahara',
        deName: 'Westsahara',
        code: 'eh'
    },
    { enName: 'Yemen', deName: 'Jemen', code: 'ye' },
    {
        enName: 'Zambia',
        deName: 'Sambia',
        code: 'zm'
    },
    { enName: 'Zimbabwe', deName: 'Simbabwe', code: 'zw' }
];
